module.exports = __webpack_public_path__ + "img/spaghetti-met-tomatensaus.0532c150.jpeg";